<template>
<b-container class="mt-5 pb-5" :style="{ backgroundColor:bgColor}" fluid>
  <b-row>
    <b-col class="text-center">
      <h1 class="block-text">
	<slot name="header">Ready to manage your Files the smart way?</slot>
      </h1>
    </b-col>
  </b-row>
  <b-row>
    <b-col class="text-center py-5">
      <slot name="buttons">
	<b-button
	  size="lg"
	  class="btn-outline-neon-blue text-dark px-5 mx-auto mr-sm-4 mb-2"
	  href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s"
	  target="_blank"
	  >
	  Contact Us
	</b-button>
	<b-button
	  size="lg"
	  class="btn-neon-blue mb-2"
	  href="https://trinpod.us/pricing?industry=productivity"
	  >
	  Get Started
	</b-button>
      </slot>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout08",
    props: {
	bgColor: String
    }
}
</script>

<style>
h1.block-text {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    color: #21212100; 
    font-size: 3.5rem !important;
    font-weight: 700 !important; 
    -webkit-text-stroke: 2px #222; 
    position: relative;
    top: -39px; 
    text-transform: uppercase;
}
</style>
